<script>
import Vue from 'vue';
import {required, sameAs} from 'vuelidate/lib/validators'
import {mapState, mapActions} from 'vuex';
import {validatePassword} from "../../services/ValidatorService";
import PreloaderItem from '../PreloaderItem/PreloaderItem.vue';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue';

export default Vue.extend({
    components: {
        PreloaderItem,
        SelectLanguage
    },
    data () {
        return {
            pass: undefined,
            passCheck: undefined,
            timer: 5,
            interval: undefined,
            submitted: false
        }
    },
    validations() {
        return {
            pass: {
                required,
                validatePassword: (password) => {
                    return validatePassword(password).valid
                }
            },
            passCheck: {
                required,
                validatePassword: (password) => {
                    return validatePassword(password).valid
                },
                sameAsPassword: sameAs('pass')
            }
        }
    },
    computed: {
        ...mapState({
            loading: state => state.auth.reset.loading,
            message: state => state.auth.reset.message
        }),
        passClasses () {
            return {
                'reset-password-page__input--error': this.$v.pass.$dirty && this.$v.pass.$error,
                'reset-password-page__input--success': this.$v.pass.$dirty && !this.$v.pass.$error
            }
        },
        passCheckClasses () {
            return {
                'reset-password-page__input--error': this.$v.passCheck.$dirty && this.$v.passCheck.$error,
                'reset-password-page__input--success': this.$v.passCheck.$dirty && !this.$v.passCheck.$error
            }
        }
    },
    methods: {
        ...mapActions({
            resetPassword: 'auth/resetPassword'
        }),
        submit () {
            this.$v.$touch();

            if (!this.$v.pass.$error && !this.$v.passCheck.$error) {
                this.resetPassword({
                    pass: this.pass,
                    token: this.$route.params.token
                }).then(() => {
                    this.submitted = true;
                    this.interval = setInterval(() => {
                        this.timer = this.timer - 1;
                        if (this.timer === 0) {
                            clearInterval(this.interval);
                            this.$router.push('/');
                        }
                    }, 1000);
                });
            }
        }
    }
});
</script>
<template>
    <div class="reset-password-page">
        <div class="reset-password-page__heading">{{ $t('resetPassword.heading') }}</div>
        <div class="reset-password-page__paragraph">{{ $t('resetPassword.description') }}</div>
        <div v-if="message" :class="`reset-password-page__alert--${message.level}`" class="reset-password-page__alert">
            {{ $t(message.text) }}
            <span v-if="message.level === 'success'">{{ timer }}</span>
        </div>
        <div class="reset-password-page__form">
            <div class="reset-password-page__input-group">
                <input :placeholder="$t('resetPassword.pass.placeholder')"
                       v-model="pass"
                       :class="passClasses"
                       type="password"
                       class="reset-password-page__input"
                       autocomplete="off"
                       @input="$v.pass.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.pass.$dirty && !$v.pass.required" class="reset-password-page__input-help">
                    {{ $t('resetPassword.pass.errors.required') }}
                </span>
                <span v-if="$v.pass.$dirty && !$v.pass.validatePassword" class="reset-password-page__input-help">
                    {{ $t('account.password.validator.password') }}
                </span>
            </div>
            <div class="reset-password-page__input-group">
                <input :placeholder="$t('resetPassword.passCheck.placeholder')"
                       v-model="passCheck"
                       :class="passCheckClasses"
                       type="password"
                       class="reset-password-page__input"
                       autocomplete="off"
                       @input="$v.passCheck.$touch()"
                       @keyup.enter="submit">
                <span v-if="$v.passCheck.$dirty && !$v.passCheck.sameAsPassword" class="reset-password-page__input-help">
                    {{ $t('resetPassword.passCheck.errors.mismatch') }}
                </span>
                <span v-if="$v.passCheck.$dirty && !$v.passCheck.required" class="reset-password-page__input-help">
                    {{ $t('resetPassword.passCheck.errors.required') }}
                </span>
            </div>
            <div class="reset-password-page__input-group">
                <button :disabled="loading || submitted"
                        class="reset-password-page__submit"
                        @click="submit">
                    <span v-if="!loading">{{ $t('resetPassword.button') }}</span>
                    <preloader-item v-if="loading"/>
                </button>
            </div>
            <select-language/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ResetPasswordPage/ResetPasswordPage.vue